// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { init } from '@sentry/nextjs';

const SENTRY_DSN =
  process.env.SENTRY_DSN ||
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://ce541ea956614a59a21d500840e8f850@o1352178.ingest.sentry.io/6640207';

const SENTRY_ENVIRONMENT =
  process.env.SENTRY_ENVIRONMENT ||
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ||
  'local';

init({
  dsn: SENTRY_DSN,
  defaultIntegrations: false,
  enabled: process.env.NODE_ENV === 'production',
  environment: SENTRY_ENVIRONMENT + '-client',
  ignoreErrors: [
    'https://reactjs.org/docs/error-decoder.html?invariant=422', // There was an error while hydrating this Suspense boundary. Switched to client rendering.
    'https://reactjs.org/docs/error-decoder.html?invariant=423', // There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root...
    'https://reactjs.org/docs/error-decoder.html?invariant=425' // Text content does not match server-rendered HTML...
  ],
  tracesSampleRate: 0.2
});
